((function () {

    const isIntAndNotEmpty = (value) => {
        return Number.isInteger(value) && value > 0;
    };

    document.querySelectorAll('[data-adev-main-product]').forEach(function (productEl) {

        const variantsJsonEl = productEl.querySelector('[data-adev-variants-json]');
        if (!variantsJsonEl) return;

        const variantsJson = JSON.parse(variantsJsonEl.innerHTML);
        
        const variants = variantsJson.variants;
        
        const auto_select_variant_id = window.adev_auto_select_variant;
        if (!isIntAndNotEmpty(auto_select_variant_id)) return;

        const variant = variants.find(v => v.id === parseInt(auto_select_variant_id));
        if (!variant) return;

        const options = variant.options;

        options.forEach(function (option) {
            const optionEl = productEl.querySelector(`[data-adev-variant-input="${option}"]`);
            if (optionEl) {
                optionEl.checked = true;
                optionEl.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

    });

})());